import $ from 'jquery'
import 'slick-carousel'

export default class StoryImageSeriesController {
  constructor (element) {
    this._element = element
    this._initSlick()
  }

  _initSlick () {
    console.log('init slick', this._element)
    $(this._element).slick({
      slidesToShow: 1,
      // speed: 10000,
      // autoplay: true,
      // autoplaySpeed: 0,
      // pauseOnFocus: false,
      // pauseOnHover: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
      mobileFirst: true,
      prevArrow: null, // '.' + previousButtonClass,
      nextArrow: null, // '.' + nextButtonClass,
      variableWidth: true,
      centerMode: true,
      pauseOnHover: false,
      draggable: false,
      swipeToSlide: true
    })
  }
}
